﻿// @ts-nocheck
// attachEventListeners

function attachEventListeners() {
  // Mobile hamburger toggle for tab nav
  const tabNavShell = document.getElementById("tabNavShell");
  const tabNavToggle = document.getElementById("tabNavToggle");
  if (tabNavShell && tabNavToggle) {
    tabNavToggle.addEventListener("click", () => {
      const open = tabNavShell.classList.toggle("open");
      tabNavToggle.setAttribute("aria-expanded", open ? "true" : "false");
      tabNavToggle.setAttribute("aria-label", open ? "Close menu" : "Open menu");
    });
  }

  // Tab switching
  const tabBtns = document.querySelectorAll(".tab-btn");
  tabBtns.forEach((btn) => {
    btn.addEventListener("click", () => {
      const tabName = btn.getAttribute("data-tab");
      if (tabName) switchTab(tabName);
      if (tabNavShell && tabNavShell.classList.contains("open")) {
        tabNavShell.classList.remove("open");
        if (tabNavToggle) {
          tabNavToggle.setAttribute("aria-expanded", "false");
          tabNavToggle.setAttribute("aria-label", "Open menu");
        }
      }
    });
    btn.addEventListener("keydown", (e) => {
      const buttons = Array.from(document.querySelectorAll(".tab-btn"));
      const currentIndex = buttons.indexOf(btn);
      if (currentIndex === -1) return;
      if (e.key === "ArrowRight") {
        e.preventDefault();
        buttons[(currentIndex + 1) % buttons.length].focus();
      }
      if (e.key === "ArrowLeft") {
        e.preventDefault();
        buttons[(currentIndex - 1 + buttons.length) % buttons.length].focus();
      }
      if (e.key === "Home") {
        e.preventDefault();
        buttons[0].focus();
      }
      if (e.key === "End") {
        e.preventDefault();
        buttons[buttons.length - 1].focus();
      }
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        const tabName = btn.getAttribute("data-tab");
        if (tabName) switchTab(tabName);
      }
    });
  });

  // Reports month selector
  const reportMonthSelect = document.getElementById("reportMonthSelect");
  if (reportMonthSelect) {
    reportMonthSelect.addEventListener("change", (e) => {
      const month = e.target.value;
      if (month) renderMonthlyReport(month);
    });
    populateMonthSelect();
  }

  // Projects
  const addProjectBtn = document.getElementById("addProjectBtn");
  if (addProjectBtn) {
    addProjectBtn.addEventListener("click", addProject);
  }

  // Clients
  const addClientBtn = document.getElementById("addClientBtn");
  if (addClientBtn) {
    addClientBtn.addEventListener("click", addClient);
  }

  const refreshBtn = document.getElementById("refreshBtn");
  if (refreshBtn) {
    refreshBtn.addEventListener("click", () => loadSessions());
  }

  const exportBtn = document.getElementById("exportBtn");
  if (exportBtn) {
    exportBtn.addEventListener("click", () => {
      window.location.href = "/api/export";
    });
  }

  // Manual logging
  const addManualSessionBtn = document.getElementById("addManualSessionBtn");
  if (addManualSessionBtn) {
    addManualSessionBtn.addEventListener("click", addManualSession);
  }

  // AI
  const aiSendBtn = document.getElementById("aiSendBtn");
  if (aiSendBtn) {
    aiSendBtn.addEventListener("click", () => {
      const aiInput = document.getElementById("aiInput");
      const text = aiInput.value.trim();
      if (text) sendAiQuestion(text);
    });
  }

  const aiInput = document.getElementById("aiInput");
  if (aiInput) {
    aiInput.addEventListener("keydown", (e) => {
      if (e.key === "Enter" && (e.ctrlKey || e.metaKey)) {
        e.preventDefault();
        const text = aiInput.value.trim();
        if (text) sendAiQuestion(text);
      }
    });
  }

  const quickSummary = document.getElementById("quickSummary");
  if (quickSummary) {
    quickSummary.addEventListener("click", () => {
      sendAiQuestion(
        currentBillingModel() === "service_based"
          ? "Summarize today's schedule, open jobs, and anything that should be invoiced or followed up on."
          : "Summarize all my work today by project with total hours and earnings.",
      );
    });
  }

  const quickInvoice = document.getElementById("quickInvoice");
  if (quickInvoice) {
    quickInvoice.addEventListener("click", () => {
      sendAiQuestion(
        currentBillingModel() === "service_based"
          ? "Draft a concise invoice summary for completed jobs that are ready to bill today."
          : "Draft a concise invoice summary for today's work, organized by client/project, ready to send to clients.",
      );
    });
  }

  // Invoice Generator
  const invoiceMonthSelect = document.getElementById("invoiceMonthSelect");
  if (invoiceMonthSelect) {
    invoiceMonthSelect.addEventListener("change", populateInvoiceClients);
  }

  const invoiceClientSelect = document.getElementById("invoiceClientSelect");
  if (invoiceClientSelect) {
    invoiceClientSelect.addEventListener("change", (e) => {
      setInvoiceStateFromProject(e.target.value);
    });
  }

  const generateInvoiceBtn = document.getElementById("generateInvoiceBtn");
  if (generateInvoiceBtn) {
    generateInvoiceBtn.addEventListener("click", generateInvoice);
  }

  const downloadInvoiceBtn = document.getElementById("downloadInvoiceBtn");
  if (downloadInvoiceBtn) {
    downloadInvoiceBtn.addEventListener("click", downloadInvoicePDF);
  }

  // Cleanup tools
  const scanDataBtn = document.getElementById("scanDataBtn");
  if (scanDataBtn) {
    scanDataBtn.addEventListener("click", scanAndShowCleanupSuggestions);
  }

  const addJobBtn = document.getElementById("addJobBtn");
  if (addJobBtn) {
    addJobBtn.addEventListener("click", addJob);
  }

  const newJobRecurrence = document.getElementById("newJobRecurrence");
  if (newJobRecurrence) {
    const seasonRow = document.getElementById("newJobSeasonRow");
    const sync = () => {
      if (!seasonRow) return;
      seasonRow.style.display = newJobRecurrence.value && newJobRecurrence.value !== "none" ? "" : "none";
    };
    newJobRecurrence.addEventListener("change", sync);
    sync();
  }

  // Schedule tab
  const newApptBtn = document.getElementById("newApptBtn");
  if (newApptBtn) newApptBtn.addEventListener("click", () => openApptModal(scheduleSelectedDate || new Date().toISOString().slice(0, 10), null));

  const schedPrevBtn = document.getElementById("schedPrevBtn");
  if (schedPrevBtn) schedPrevBtn.addEventListener("click", () => {
    scheduleCurrentMonth = new Date(scheduleCurrentMonth.getFullYear(), scheduleCurrentMonth.getMonth() - 1, 1);
    renderScheduleCalendar();
  });

  const schedNextBtn = document.getElementById("schedNextBtn");
  if (schedNextBtn) schedNextBtn.addEventListener("click", () => {
    scheduleCurrentMonth = new Date(scheduleCurrentMonth.getFullYear(), scheduleCurrentMonth.getMonth() + 1, 1);
    renderScheduleCalendar();
  });

  const apptModalCancelBtn = document.getElementById("apptModalCancelBtn");
  if (apptModalCancelBtn) apptModalCancelBtn.addEventListener("click", closeApptModal);

  const apptModalSaveBtn = document.getElementById("apptModalSaveBtn");
  if (apptModalSaveBtn) apptModalSaveBtn.addEventListener("click", saveAppt);

  // Close modal on backdrop click
  const apptModal = document.getElementById("apptModal");
  if (apptModal) apptModal.addEventListener("click", (e) => { if (e.target === apptModal) closeApptModal(); });

  // Add correction/data fix quick button
  const quickButtons = document.getElementById("quickButtons");
  if (quickButtons) {
    const correctButton = document.createElement("button");
    correctButton.className = "btn btn-secondary btn-sm";
    correctButton.textContent = "📝 Fix Time Entry";
    correctButton.style.cssText = "font-size: 0.75rem; padding: 0.375rem 0.75rem; cursor: help;";
    correctButton.title = "Click to see examples of how to correct time entries with AI";
    correctButton.addEventListener("click", () => {
      alert("Examples of how to ask AI to fix time entries:\n\n" +
        "• 'Add 2 hours to Project X for today'\n" +
        "• 'I actually worked 3.5 hours, not 2 hours on Client Y yesterday'\n" +
        "• 'Delete the last session I created today'\n" +
        "• 'Change all Project Z sessions to $250/hr'\n" +
        "• 'Add 1.5 hours of work on Client A on Monday at 9am-10:30am'\n" +
        "• 'I need to remove a session from 2pm today'\n\n" +
        "The AI will suggest changes and ask for confirmation before applying!");
    });
    quickButtons.appendChild(correctButton);
  }
}
